import { DocumentChunk } from './document-chunk';
import isPlural from '@/helpers/isPlural';
import { Button } from '@/new/components/shadcn/button';
import { Chunk } from '@/types';

interface SupportingChunksProps {
  chunks: Chunk[];
  showAllChunks: boolean;
  setShowAllChunks: (bool: boolean) => void;
}

export function SupportingChunks({ chunks, setShowAllChunks, showAllChunks }: SupportingChunksProps) {
  if (chunks.length === 0) {
    return null;
  }

  return (
    <div className="mb-2 text-xs">
      <Button
        variant="outline"
        size="sm"
        className="my-2 text-orange-600 shadow-none hover:bg-gray-100 hover:text-orange-800"
        onClick={() => setShowAllChunks(!showAllChunks)}
      >
        {showAllChunks
          ? 'Hide additional supporting texts'
          : `Show ${chunks.length} supporting ${isPlural({
              one: 'text',
              more: 'texts',
              number: chunks.length,
            })}...`}
      </Button>

      {showAllChunks && (
        <div className="mt-2 flex flex-col gap-2">
          {chunks.map((chunk) => (
            <div key={chunk.id} id={chunk.id}>
              <DocumentChunk chunk={chunk} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
